import { useReinstallService } from './handlers/install'
import FormTwilio from './Form/FormTwilio'
import { assoc, compose } from 'ramda'
import { pick } from 'lodash'

export const TWILIO = {
  key: 'twilio',
  onReinstall: useReinstallService,
  Form: FormTwilio,
  SCOPE: []
}

export default TWILIO
